import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OrganisationService {

  constructor(private httpClient: HttpClient) { }

  api_root: string = environment.REST_API_SERVER;

  public createNewWorkspace(workspaceName: string) {
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/';
    const data = {
      "title": workspaceName
    }

    return this.httpClient.post<any>(url, data);
  }

  public getWorkspaceList() {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/';
    return this.httpClient.get(similar_url).pipe(map(data => {
      return data['results'];
    }));
  }

  public getUsersWorkspaceList(workspaceId: any, userId: any) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/' + workspaceId + '/get_workspace_unadded/?target_user_id=' + userId;
    return this.httpClient.get(similar_url).pipe(map(data => {
      return data;
    }));
  }

  public deleteWorkspace(workspaceId: any) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/' + workspaceId + '/';
    return this.httpClient.delete(similar_url);
  }

  public getCategories() {
    return this.httpClient.get(this.api_root + 'categories/');
  }

  public showOfferDialogApi() {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'users/get_dialog/';
    return this.httpClient.get(similar_url).pipe(map(data => {
      return data['results'];
    }));
  }

  public userSeenOfferDialogApi(dialogId: any, actioned: any) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'users/set_dialog_seen/';
    const data = {
      "dialog_id": dialogId,
      "user_action": actioned
    }
    return this.httpClient.post<any>(similar_url, data);
  }
}
